import React, { useContext, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardHeader,
  CardFooter,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { UserContext } from "../../context/UserContext";
import { Redirect } from "react-router-dom";
const Test4 = () => {
  const context = useContext(UserContext);

  const [email, setEmail] = useState(context.user?.otpemail);
  console.log(setEmail)
  const [otp, setOtp] = useState("");
  // const [password,setPassword]=useState('')
  const logindata = {
    email: "",    otp: "",
  };
  if(context.user===null)
  {
    toast.error("Seems that you have refresh Page,try again", {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  } 
  const handleFormSubmit = (e) => {
    e.preventDefault();
    verifyotp();
  };
  const verifyotp = async () => {
    if (otp === "") {
      toast.error("Otp is Empty", { position: toast.POSITION.BOTTOM_LEFT });
      return;
    } else if (!validator.isNumeric(otp)) {
      toast.error("Please Enter valid OTP", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    logindata.otp = otp;
    await Axios.post("Login/checkotp", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.msg === "true") {
          toast.success("Otp match successfully!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          context.setUser({otp:res.data.status,otpemail:email})
          return res;
        } else if (res.data.status === "200" && res.data.msg === "false") {
          toast.error("Otp did not match!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          setOtp("");
          return res;
        } else if (res.data.status === "200" && res.data.msg === "expired") {
          toast.error("Otp Expired.!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return res;
        } else {
          toast.error("Something went wrong", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
        throw res;
      })
      .then((resJson) => {})
      .catch((error) => {
        console.log("error123", error);
      });
      
  };
  if(context.user?.otp)
      {
        return <Redirect to="/test5"/>
      }
      else if(context.user===null)
      {
        return<Redirect to="/test3"/>
      }
  return (
    <div>
      <Container className="text-center">
        <Row>
          <Col lg={6} className="offset-lg-3 mt-5">
            <Card>
              <Form onSubmit={handleFormSubmit}>
                <CardHeader className="">Enter Otp here{this?.props?.location?.state?.email}</CardHeader>
                <CardBody>
                  <FormGroup row>
                    <Label for="email" sm={3}>
                      username
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="emai"
                        id="emai"
                        value={email}
                        disabled={true}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="email" sm={3}>
                      OTP
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        name="otp"
                        id="otp"
                        placeholder="Enter Otp Here"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  {email ? <Button type="submit" block color="primary">
                    Verify OTP
                  </Button>:"Invalid Request"}
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Test4;
